"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Common = void 0;
const ReplacesEnum_1 = require("../ReplacesEnum");
exports.Common = Object.freeze({
    EXTENSION_NAME: 'Omnito Meeting Booker: Agendamento sem falhas',
    EXTENSION_SHORT_NAME: 'Omnito Inbox',
    EXTENSION_DESCRIPTION: 'Simplifique o agendamento! Com um clique, conecte seu calendário, defina sua disponibilidade e envie convites para garantir que você nunca terá conflitos de horário.',
    EXTENSION_BUTTON_TOOLTIP: 'Inserir Omnito Meeting Booker',
    AUTHORIZATION_SERVER_ONE: 'Omnito',
    AUTHORIZATION_SERVER_SALESFORCE: 'Omnito para Salesforce (CEP)',
    AUTHORIZATION_SERVER_SALESFORCE_PRODUCTION: 'Produção',
    AUTHORIZATION_SERVER_SALESFORCE_SANDBOX: 'Sandbox',
    ACTIVE_TAB_SIDEBAR_SUMO1_LOGIN_TITLE: 'Omnito',
    ACTIVE_TAB_SIDEBAR_SALESFORCE_LOGIN_TITLE: 'Omnito para Salesforce',
    ACTIVE_TAB_SIDEBAR_LOGIN_BUTTON: 'Entrar',
    ACTIVE_TAB_SIDEBAR_LOGIN_WITH_GOOGLE_BUTTON: 'Entrar com Google',
    ACTIVE_TAB_SIDEBAR_LOGIN_WITH_MICROSOFT_BUTTON: 'Entrar com Microsoft',
    ACTIVE_TAB_SIDEBAR_LOGIN_WITH_SALESFORCE_BUTTON: 'Entrar com Salesforce',
    ACTIVE_TAB_SIDEBAR_LOGIN_WITH_SALESFORCE_PRODUCTION_BUTTON: 'Produção',
    ACTIVE_TAB_SIDEBAR_LOGIN_WITH_SALESFORCE_SANDBOX_BUTTON: 'Sandbox',
    ACTIVE_TAB_SIDEBAR_LOGIN_TRIAL_TEXT: 'Ainda não tem uma conta?',
    ACTIVE_TAB_SIDEBAR_LOGIN_TRIAL_LINK: 'Registar-se',
    ACTIVE_TAB_SIDEBAR_CREATE_MEETING_BUTTON: 'Criar reunião',
    ACTIVE_TAB_SIDEBAR_WELCOME_LABEL_LOGGED_IN: 'Bem-vindo, você está autenticado.',
    ACTIVE_TAB_SIDEBAR_WELCOME_LABEL_LOGGED_IN_CREATE_MEETING_BUTTON: 'Clique em Criar reunião para inserir horários no seu e-mail.',
    ACTIVE_TAB_SIDEBAR_WELCOME_LIST_ITEM_1: "1. Abra <a target='_blank' class='text-blue-100 no-underline' href='https://mail.google.com'>Gmail.com</a> ou <a target='_blank' class='text-blue-100 no-underline' href='https://outlook.live.com'>Outlook.live.com</a> e crie um novo e-mail",
    GMAIL_URL: 'gmail.com',
    OUTLOOK_URL: 'outlook.live.com',
    ACTIVE_TAB_SIDEBAR_WELCOME_LIST_ITEM_2: '2. Clique no ícone do Meeting Booker',
    ACTIVE_TAB_SIDEBAR_WELCOME_LOGOUT_BUTTON: 'Sair',
    ACTIVE_TAB_SETTINGS_LOGOUT_BUTTON: 'Sair',
    SCHEDULER_DEFAULT_WORKSPACE_LABEL: 'Espaço de trabalho padrão',
    SCHEDULER_WORKSPACE_LABEL: 'Espaço de trabalho',
    SCHEDULER_WORKSPACE_TOOLTIP: 'A lista de serviços e anfitriões será atualizada com base no espaço de trabalho selecionado',
    SCHEDULER_SETTINGS_DEFAULT_PROCESS_LABEL: 'Processo padrão',
    SCHEDULER_SETTINGS_DEFAULT_HOST_LABEL: 'Anfitrião padrão',
    SCHEDULER_SETTINGS_HOST_ME_LABEL: 'Eu',
    SCHEDULER_SETTINGS_HOST_NONE_LABEL: 'Nenhum',
    SCHEDULER_SETTINGS_BUTTON: 'Configurações',
    SCHEDULER_SETTINGS_TOOLTIP: 'Configurações',
    SCHEDULER_MEETING_NAME_LABEL: 'Nome da reunião',
    SCHEDULER_APPOINTMENT_TITLE_LABEL: 'Título / Tipo de compromisso',
    SCHEDULER_APPOINTMENT_TYPES_LABEL: 'Tipos de compromisso',
    SCHEDULER_APPOINTMENT_TYPES_PLACEHOLDER: 'Selecionar tipos de compromisso',
    SCHEDULER_APPOINTMENT_TYPES_SEARCH_PLACEHOLDER: 'Pesquisar',
    SCHEDULER_APPOINTMENT_TYPES_MAX_WARNING: `No máximo ${ReplacesEnum_1.ReplacesDetailEnum.MAX} podem ser selecionados.`,
    SCHEDULER_APPOINTMENT_TITLE_ONLY_LABEL: 'Título do compromisso',
    SCHEDULER_APPOINTMENT_TITLE_ONLY_PLACEHOLDER: 'Inserir título do compromisso',
    SCHEDULER_TITLE_PLACEHOLDER: 'Inserir nome',
    SCHEDULER_MEETING_TYPE_LABEL: 'Meeting Type',
    SCHEDULER_MEETING_TYPES_LABEL: 'Meeting Types',
    SCHEDULER_TEMPLATE_PLACEHOLDER: 'Selecionar',
    SCHEDULER_DURATION_LABEL: 'Duração',
    SCHEDULER_TOTAL_DURATION_LABEL: 'Duração total',
    SCHEDULER_DURATION_DIMENSION_MINUTES_FULL_LABEL: 'minutos',
    SCHEDULER_DURATION_DIMENSION_HOURS_FULL_LABEL: 'horas',
    SCHEDULER_DURATION_DIMENSION_MINUTES_SHORT_LABEL: 'min',
    SCHEDULER_DURATION_DIMENSION_HOURS_SHORT_LABEL: 'h',
    SCHEDULER_DURATION: 'duração',
    SCHEDULER_BUFFER: 'intervalo',
    SCHEDULER_BUFFER_TIME_NONE_LABEL: 'Nenhum',
    SCHEDULER_BUFFER_TIME_MIN5_LABEL: '5 min',
    SCHEDULER_BUFFER_TIME_MIN10_LABEL: '10 min',
    SCHEDULER_BUFFER_TIME_MIN15_LABEL: '15 min',
    SCHEDULER_BUFFER_TIME_MIN20_LABEL: '20 min',
    SCHEDULER_BUFFER_TIME_MIN25_LABEL: '25 min',
    SCHEDULER_BUFFER_TIME_MIN30_LABEL: '30 min',
    SCHEDULER_BUFFER_TIME_MIN35_LABEL: '35 min',
    SCHEDULER_BUFFER_TIME_MIN40_LABEL: '40 min',
    SCHEDULER_BUFFER_TIME_MIN45_LABEL: '45 min',
    SCHEDULER_BUFFER_TIME_MIN50_LABEL: '50 min',
    SCHEDULER_BUFFER_TIME_MIN55_LABEL: '55 min',
    SCHEDULER_BUFFER_TIME_MIN60_LABEL: '60 min',
    SCHEDULER_BUFFER_LABEL: 'Intervalo',
    SCHEDULER_BUFFER_TOOLTIP: 'Bloqueia a agenda do anfitrião antes e/ou depois desta reunião por essa duração. Intervalos são usados geralmente para preparação, pós-reunião ou deslocamento em encontros presenciais.',
    SCHEDULER_BUFFER_BEFORE_LABEL: 'Antes',
    SCHEDULER_BUFFER_AFTER_LABEL: 'Depois',
    SCHEDULER_LOCATION_LABEL: 'Local',
    SCHEDULER_LOCATION_VIDEO_CONFERENCE: 'Videoconferência',
    SCHEDULER_LOCATION_IN_PERSON: 'Presencial',
    SCHEDULER_LOCATION_PHONE: 'Telefone',
    SCHEDULER_LOCATION_PHONE_HOST_PHONE: 'Anfitrião',
    SCHEDULER_LOCATION_PHONE_INVITEE_PHONE: 'Convidado',
    SCHEDULER_LOCATION_PHONE_CUSTOM_PHONE: 'Personalizado',
    SCHEDULER_LOCATION_INTEGRATION_ENABLED_LABEL: 'Incluir detalhes da videoconferência',
    SCHEDULER_LOCATION_INTEGRATION_ZOOM_LABEL: 'Zoom',
    SCHEDULER_LOCATION_INTEGRATION_GOOGLE_MEET_LABEL: 'Google Meet',
    SCHEDULER_LOCATION_INTEGRATION_MICROSOFT_TEAMS_LABEL: 'Microsoft Teams',
    SCHEDULER_LOCATION_PHYSICAL_ADDRESS_PLACEHOLDER: 'Selecionar endereço',
    SCHEDULER_LOCATION_ROOM_PLACEHOLDER: 'Sala',
    SCHEDULER_LOCATION_RESOURCES_PLACEHOLDER: 'Recursos',
    SCHEDULER_LOCATION_CUSTOM_ADDRESS_PLACEHOLDER: 'Inserir endereço personalizado',
    SCHEDULER_LOCATION_PHONE_CUSTOM_PLACEHOLDER: 'Inserir número de telefone',
    SCHEDULER_LOCATION_IN_PERSON_LOCATION: 'Locais da organização',
    SCHEDULER_LOCATION_IN_PERSON_CUSTOM_ADDRESS: 'Endereço personalizado',
    SCHEDULER_LOCATION_IN_PERSON_INVITEE_LOCATION: 'Local do convidado',
    SCHEDULER_AVAILABILITY_LABEL: 'Disponibilidade',
    SCHEDULER_AVAILABILITY_TOOLTIP: 'O modo aberto oferecerá ao convidado principal o maior número de datas/horários disponíveis. As opções adicionais (personalizado, janela contínua, intervalo de datas) permitem restringir os horários oferecidos.',
    SCHEDULER_AVAILABILITY_OPEN: 'Aberto',
    SCHEDULER_AVAILABILITY_CUSTOM: 'Personalizado',
    SCHEDULER_AVAILABILITY_ROLLING: 'Contínuo',
    SCHEDULER_AVAILABILITY_RANGE: 'Intervalo',
    SCHEDULER_AVAILABILITY_OPEN_DESCRIPTION: 'Esta reunião pode ser agendada em qualquer horário disponível a partir do momento em que o participante clicar no link do convite.',
    SCHEDULER_AVAILABILITY_CUSTOM_DESCRIPTION: 'No calendário, você pode definir sua disponibilidade personalizada para este convite. Os participantes verão apenas os horários definidos como disponíveis.',
    SCHEDULER_AVAILABILITY_ROLLING_DESCRIPTION: 'Serão oferecidos horários disponíveis aos participantes durante um período que começa quando eles clicam no link do convite.',
    SCHEDULER_AVAILABILITY_ROLLING_WINDOW_LABEL: 'Janela (dias)',
    SCHEDULER_AVAILABILITY_ROLLING_EXPIRATION_LABEL: 'Expiração',
    SCHEDULER_AVAILABILITY_ROLLING_EXPIRATION_PLACEHOLDER: 'Nunca',
    SCHEDULER_AVAILABILITY_RANGE_DESCRIPTION: 'Selecione um intervalo de datas de disponibilidade a ser oferecido.',
    SCHEDULER_AVAILABILITY_RANGE_START_LABEL: 'Início',
    SCHEDULER_AVAILABILITY_RANGE_START_DATE_PLACEHOLDER: 'Data de início',
    SCHEDULER_AVAILABILITY_RANGE_START_TIME_PLACEHOLDER: 'Hora de início',
    SCHEDULER_AVAILABILITY_RANGE_END_LABEL: 'Fim',
    SCHEDULER_AVAILABILITY_RANGE_END_DATE_PLACEHOLDER: 'Data de término',
    SCHEDULER_AVAILABILITY_RANGE_END_TIME_PLACEHOLDER: 'Hora de término',
    SCHEDULER_LIMIT_LABEL: 'Limite',
    SCHEDULER_LIMIT_TOOLTIP: 'Limite o número de compromissos que podem ser reservados com este convite/link. Após atingir o limite, o convite/link expirará automaticamente.',
    SCHEDULER_LIMIT_LIMIT1_LABEL: '1',
    SCHEDULER_LIMIT_LIMIT2_LABEL: '2',
    SCHEDULER_LIMIT_LIMIT3_LABEL: '3',
    SCHEDULER_LIMIT_LIMIT4_LABEL: '4',
    SCHEDULER_LIMIT_LIMIT5_LABEL: '5',
    SCHEDULER_LIMIT_LIMIT6_LABEL: '6',
    SCHEDULER_LIMIT_LIMIT7_LABEL: '7',
    SCHEDULER_LIMIT_LIMIT8_LABEL: '8',
    SCHEDULER_LIMIT_LIMIT9_LABEL: '9',
    SCHEDULER_LIMIT_LIMIT10_LABEL: '10',
    SCHEDULER_LIMIT_UNLIMITED_LABEL: 'Ilimitado',
    SCHEDULER_HOST_LABEL: 'Anfitrião',
    SCHEDULER_HOST_PLACEHOLDER: 'Adicionar anfitrião',
    SCHEDULER_ADD_GUEST_LABEL: 'Adicionar convidados',
    SCHEDULER_ADD_GUEST_PLACEHOLDER: 'Pesquisar por nome ou e-mail',
    SCHEDULER_MAIN_GUEST_LABEL: 'Convidado',
    SCHEDULER_NOTE_LABEL: 'Nota para convidado e participantes',
    SCHEDULER_MAIN_GUEST_TOOLTIP: 'Se o convidado for definido, clique em “Inserir horários e fechar” para adicionar horários ao e-mail. Caso contrário, clique em “Copiar link e fechar” para enviá-lo a qualquer pessoa; o convidado poderá se identificar ao reservar.',
    SCHEDULER_MAIN_GUEST_PLACEHOLDER: 'Pesquisar por nome ou e-mail',
    SCHEDULER_GUESTS_LABEL: 'Participantes',
    SCHEDULER_DESCRIPTION_LABEL: 'Nota do anfitrião',
    SCHEDULER_INSERT_BUTTON_LABEL: 'Inserir horários e fechar',
    SCHEDULER_BOOK_AND_CLOSE_BUTTON_LABEL: 'Reservar e fechar',
    SCHEDULER_BOOK_AND_NEW_BUTTON_LABEL: 'Reservar e novo',
    SCHEDULER_INSERT_BUTTON_TOOLTIP: 'Inserirá horários disponíveis no seu e-mail.',
    SCHEDULER_BOOK_AND_NEW_BUTTON_TOOLTIP: 'Reserva imediatamente e reinicia para uma nova reserva.',
    SCHEDULER_BOOK_AND_CLOSE_BUTTON_TOOLTIP: 'Reserva imediatamente e fecha o Meeting Booker.',
    SCHEDULER_COPY_LINK_BUTTON_LABEL: 'Copiar link e fechar',
    SCHEDULER_COPY_LINK_BUTTON_TOOLTIP: 'Copiará este link de reserva para colar em um e-mail.',
    SCHEDULER_BUTTON_PREVIOUS_WEEK: 'Semana anterior',
    SCHEDULER_BUTTON_NEXT_WEEK: 'Próxima semana',
    SCHEDULER_BUTTON_THIS_WEEK: 'Esta semana',
    SCHEDULER_BUTTON_TODAY: 'Hoje',
    SCHEDULER_ERROR: 'Erro',
    INTERNAL_SERVER_ERROR: 'Erro interno do servidor',
    INTERNAL_SERVER_ERROR_ALERT: 'A abertura em BRANCO será inserida no convite.',
    SCHEDULER_CREATE_BOOKING_PAGE_ERROR: 'Falha na solicitação CreateBookingPage. Tente novamente mais tarde',
    SCHEDULER_CREATE_BOOKING_PAGE_LIMIT_ERROR: 'Atualize sua oferta, você atingiu o limite.',
    SCHEDULER_CREATE_BOOKING_PAGE_LIMIT_LINK: 'Ver planos',
    SCHEDULER_MEMBERS_ERROR: 'Falha na solicitação de membros. Tente novamente mais tarde',
    SCHEDULER_TEMPLATE_ERROR: 'Falha na solicitação de modelos. Tente novamente mais tarde',
    GET_USER_LOGIN_ERROR_MESSAGE: 'Não existe conta com este e-mail',
    GET_USER_AUTH_ERROR_MESSAGE: 'Falha na autenticação do usuário',
    GET_USER_LOGOUT_ERROR_MESSAGE: 'Falha ao sair do usuário',
    DELETE_USER_SUCCESS_MESSAGE: 'Falha na solicitação de autenticação',
    DELETE_USER_ERROR_MESSAGE: 'Falha na exclusão do usuário',
    CHOOSE_AN_ACCOUNT_ERROR_TOAST: 'Falha ao escolher conta',
    GET_MAIN_DATA_ERROR_MESSAGE: 'Falha na solicitação de autenticação',
    ROLE_DEACTIVATED_ERROR_MESSAGE: 'Função foi desativada. Entre em contato com seu administrador Omnito.',
    USER_DEACTIVATED_ERROR_MESSAGE: 'Usuário foi desativado. Entre em contato com seu administrador Omnito.',
    TRIAL_LIMIT_ERROR_MESSAGE: 'Você ultrapassou o limite de 40 itens na versão de teste',
    ACCOUNT_ALREADY_EXIST_ERROR_TOAST_MESSAGE: 'Outra conta já está associada a este e-mail',
    DELETE_ROLE_ASSIGNED_ERROR_MESSAGE: 'Não é possível excluir. Usuários estão atribuídos a esta função.',
    INVALID_GOOGLE_MAP_API_KEY_ERROR_MESSAGE: 'Chave da API Google inválida ou serviços obrigatórios não ativados.',
    IMPORT_LOCATIONS_LIMIT_ERROR_MESSAGE: 'Falha na importação: limite de 100 locais excedido. Divida seu arquivo.',
    PRICING_TIER_ACCESS_EXCEPTION_MESSAGE: 'Atualize seu plano de assinatura para acessar este recurso.',
    RESEND_USER_INVITE_ERROR_MESSAGE: 'Um registro de administrador com este e-mail já existe nesta organização',
    ACTIVE_TAB_SIDEBAR_LICENSE_ERROR: 'Sua licença expirou. Verifique sua assinatura.',
    PLEASE_WAIT_AND_TRY_AGAIN: 'Aguarde e tente novamente',
    FAILED_TO_LOAD_SCHEDULER_DATA: 'Falha ao carregar dados do agendador...',
    MEETING_BOOKER_INSTALLED: 'Meeting Booker está instalado.',
    TRY_AGAIN: 'Tentar novamente',
    SPOTS_WIDGET_CLICK_HERE: 'Clique aqui',
    SPOTS_WIDGET_VIEW_MORE_OPTIONS: 'para ver mais opções',
    SPOTS_WIDGET_SELECT_TIME_SLOT: 'para selecionar um horário disponível',
    SCHEDULER_COPY_LINK: 'Copiar link',
    SCHEDULER_ADD_INVITEE: 'Adicionar convidado',
    SCHEDULER_ADD_ATTENDEE: 'Adicionar participante',
    SEARCH_ATTENDEE_PLACEHOLDER: 'Pesquisar ou digitar para adicionar participante',
    SEARCH_HOST_PLACEHOLDER: 'Pesquisar ou digitar para selecionar anfitrião',
    SHOW_WEEKENDS: 'Mostrar fins de semana',
    INVITEE_AMD_ATTENDEES: 'Convidado e participantes',
    SCHEDULER_BOOKING_TOOLS: 'Ferramentas de reserva',
    SCHEDULER_USER_SETTINGS: 'Configurações do usuário',
    SCHEDULER_ALL_PERSONAL_LINKS: 'Todos os links pessoais',
    SCHEDULER_TOOLS: 'Ferramentas',
    SCHEDULER_TEMPLATES: 'Modelos',
    SCHEDULER_TOOLS_AVAILABILITY: 'Disponibilidade',
    SCHEDULER_TOOLS_INTEGRATE: 'Integrações',
    SCHEDULER_TOOLS_BOOKING_PAGES: 'Tipos de reunião',
    SCHEDULER_TOOLS_MY_BOOKING_PAGES: 'Meus tipos de reunião',
    SCHEDULER_TOOLS_SHARED_BOOKING_PAGES: 'Tipos de reunião compartilhados',
    SCHEDULER_HEADER_TAB_1: 'Oferecer horário de reserva',
    SCHEDULER_HEADER_TAB_2: 'Reunião instantânea',
    SCHEDULER_DEFAULT_INVITEE_NAME_LABEL: 'Nome',
    SCHEDULER_DEFAULT_INVITEE_EMAIL_LABEL: 'E-mail',
    SCHEDULER_GUIDE_TITLE: 'Bem-vindo ao Meeting Booker',
    SCHEDULER_ONBOARDING: 'Integração',
    SCHEDULER_SKIP: 'Pular',
    SCHEDULER_GUIDE_DESCRIPTION: 'Agende reuniões sem esforço — diretamente do seu e-mail. Escolha sua disponibilidade, insira horários na mensagem e deixe os outros escolherem o que funciona melhor.',
    SCHEDULER_GUIDE_HOW_IT_WORKS: 'Como funciona',
    SCHEDULER_GUIDE_STEP_1_TITLE: 'Passo 1: Entre ou crie sua conta',
    SCHEDULER_GUIDE_STEP_1_DESCRIPTION: 'Use seu e-mail para entrar ou crie rapidamente uma nova conta para começar a usar o Meeting Booker.',
    SCHEDULER_GUIDE_STEP_2_TITLE: 'Passo 2: Redija um novo e-mail',
    SCHEDULER_GUIDE_STEP_2_DESCRIPTION: 'Escreva um e-mail e clique no ícone do Meeting Booker na barra de ferramentas.',
    SCHEDULER_GUIDE_STEP_3_TITLE: 'Passo 3: Configure sua reunião',
    SCHEDULER_GUIDE_STEP_3_DESCRIPTION: 'Escolha duração, tipo de reunião, horários, convidados e adicione uma nota — tudo sincronizado com seu calendário.',
    SCHEDULER_GUIDE_STEP_4_TITLE: 'Passo 4: Insira horários no seu e-mail',
    SCHEDULER_GUIDE_STEP_4_DESCRIPTION: 'Clique em “Inserir horários e fechar” — adicionaremos sua disponibilidade diretamente na mensagem. Envie e deixe os outros escolherem!',
    SCHEDULER_GUIDE_GET_STARTED_BUTTON: 'Começar',
    SCHEDULER_BOOKED_SUCCESS_MESSAGE: 'Está reservado!',
    SCHEDULER_BOOKED_SUCCESS_MESSAGE_CHECK_INBOX: 'Verifique sua caixa de entrada para um e-mail com todos os detalhes.',
    SCHEDULER_BOOKED_ERROR_MESSAGE: 'Horário obrigatório',
    SCHEDULER_BOOKED_ERROR_MESSAGE_PICK_TIME_SLOT: 'Selecione um horário no calendário para reservar sua reunião.',
    CHARACTER_LIMIT_REACHED: 'Limite atingido',
    SCHEDULER_TIME_SLOT_TO_SHORT_TITLE: 'Selecione um horário maior no calendário.',
    SCHEDULER_TIME_SLOT_TO_SHORT_DESCRIPTION: `Este horário é muito curto. Sua reunião requer ${ReplacesEnum_1.ReplacesDetailEnum.DURATION}.`,
    SCHEDULER_TIMEZONE_NOT_SELECTED_TITLE: 'Fuso horário não selecionado',
    SCHEDULER_TIMEZONE_NOT_SELECTED_DESCRIPTION: 'Por favor, selecione um fuso horário no menu do calendário antes de inserir horários.',
    NO_ACTIVE_WORKSPACES_TITLE: 'Nenhum espaço de trabalho ativo',
    NO_ACTIVE_WORKSPACES: 'Não há espaços de trabalho ativos no momento. Deve ser resolvido em breve — verifique mais tarde ou entre em contato com seu administrador.',
    WEEKDAYS_ONLY: 'Apenas dias úteis',
    INCLUDE_WEEKENDS: 'Incluir fins de semana',
    SUCCESS: 'Sucesso',
    ERROR: 'Erro',
    INFO: 'Info',
    WARNING: 'Aviso',
    CALENDAR_DISPLAY: 'Mostrar calendário',
    MY_BOOKING_PAGES: 'Meus tipos de reunião',
    SHARED_BOOKING_PAGES: 'Tipos de reunião compartilhados',
    SCHEDULER_MY_MEETINGS_LABEL: 'My Meetings',
    SCHEDULER_SHARED_MEETINGS_LABEL: 'Shared with me',
    SCHEDULER_TEAM_LABEL: 'Team',
    SCHEDULER_ROUND_ROBIN_LABEL: 'Round-Robin',
    SCHEDULER_POOL_LABEL: 'Pool',
    SCHEDULER_USER_DOES_NOT_HAVE_NECESSARY_PERMISSIONS: 'O usuário não tem os permissões necessárias',
    CORS_CONFIGURATION_REQUIRED_TITLE: 'CORS-Configuração requerida',
    CORS_CONFIGURATION_REQUIRED_TEXT: 'O acesso à informação do usuário está bloqueado pelas configurações CORS do Salesforce. Entre em contato com seu administrador do Salesforce para resolver este problema.',
    GMAIL_CONTACTS_TOOLTIP: 'Contatos do Gmail',
    OUTLOOK_CONTACTS_TOOLTIP: 'Contatos do Outlook',
    SALESFORCE_TOOLTIP: 'Salesforce',
    SALESFORCE_LEAD_TOOLTIP: 'Lead',
    SALESFORCE_CONTACT_TOOLTIP: 'Contact',
    SALESFORCE_PERSON_ACCOUNT_TOOLTIP: 'Person Account',
    SALESFORCE_TEAM_TOOLTIP: 'Team',
    SALESFORCE_RESOURCE_TOOLTIP: 'Resource',
    SALESFORCE_BUCKET_TOOLTIP: 'Bucket',
    SALESFORCE_USER_TOOLTIP: 'User',
    HUBSPOT_TOOLTIP: 'HubSpot',
    SUMO_FOR_SALESFORCE_CEP_TOOLTIP: 'Omnito para Salesforce (CEP)',
    SERVICE_NOW_TOOLTIP: 'ServiceNow',
    SCHEDULER_MINIMUM_NOTICE_PERIOD_LABEL: 'Período de notificação mínimo',
    SCHEDULER_DURATION_WARNING: 'Aviso: A duração total é menor do que a dos serviços selecionados.',
    SCHEDULER_HOST_LIMIT_WARNING: 'O anfitrião selecionado excedeu seu limite pessoal de compromissos para o tipo de compromisso selecionado.',
    SCHEDULER_BUSY: 'Ocupado',
    // Login
    LOGIN_OR: 'ou',
    LOGIN_EMAIL_PLACEHOLDER: 'Digite seu e-mail',
    LOGIN_CONTINUE: 'Continuar',
    LOGIN_BACK: 'Voltar',
    LOGIN_PASSWORD_LABEL: 'Senha',
    LOGIN_BUTTON: 'Entrar',
    LOGIN_FORGOT_PASSWORD: 'Esqueceu sua senha?',
    LOGIN_SEND_RECOVERY_EMAIL: 'Enviar e-mail de recuperação',
    FORGOT_PASSWORD_SUCCESS_MESSAGE: 'E-mail de recuperação enviado! Verifique sua caixa de entrada para um link de redefinição de senha.',
    LOGIN_INVALID_EMAIL: 'Por favor, digite um e-mail válido',
    LOGIN_INVALID_PASSWORD: 'Por favor, digite sua senha',
    LOGIN_NO_ACCOUNT: 'Nenhuma conta encontrada com este e-mail.',
    // MFA (TOTP)
    MFA_TITLE: 'Autenticação de dois fatores',
    MFA_SUBTITLE: 'Digite o código de 6 dígitos do seu aplicativo autenticador.',
    MFA_VERIFY: 'Verificar',
    MFA_SAVE_THIS_DEVICE: 'Salvar este dispositivo',
    MFA_INCORRECT_CODE: 'Código incorreto. Por favor, tente novamente.',
});
